import { ContactSectionContentProps } from 'components/organisms/Contact/types';

const contact: ContactSectionContentProps = {
  email: 'farhanshahriyar.ju242185@gmail.com',
  socials: {
    facebook: 'https://www.facebook.com/abirxhants',
    github: 'https://github.com/farhanshahriyar',
    linkedin: 'https://www.linkedin.com/in/mdfarhanshahriyar18/',
  },
};

export default contact;
